





























































import Vue from "vue";

export default Vue.extend({
  name: "Hobbies",

  data: () => ({}),

  methods: {
    getPhotos() {
      const items = [
        {
          album: "Upside down",
          link: "https://flic.kr/s/aHsk8eeNm5",
          img: require("@/assets/img/wallpaper/upside-down.jpg")
        },
        {
          album: "Minimalism",
          link: "https://flic.kr/s/aHsk5U4Eh1",
          img: require("@/assets/img/wallpaper/minimalism.jpg")
        },
        {
          album: "Lyon By night",
          link: "https://flic.kr/s/aHsjV4yEdv",
          img: require("@/assets/img/wallpaper/lyon-by-night.jpg")
        }
      ];
      return items;
    },
    getHobbies() {
      const items = [
        {
          name: "hobbies.bouldering",
          img: require("@/assets/img/hobbies/bouldering.jpg")
        },
        {
          name: "hobbies.tennis",
          img: require("@/assets/img/hobbies/tennis.jpg")
        },
        {
          name: "hobbies.padel",
          img: require("@/assets/img/hobbies/padel.jpg")
        },
        {
          name: "hobbies.squash",
          img: require("@/assets/img/hobbies/squash.jpg")
        },
        {
          name: "hobbies.badminton",
          img: require("@/assets/img/hobbies/badminton.jpg")
        },
        {
          name: "hobbies.foot",
          img: require("@/assets/img/hobbies/foot.jpg")
        },
        {
          name: "hobbies.running",
          img: require("@/assets/img/hobbies/running.jpg")
        },
        {
          name: "hobbies.swim",
          img: require("@/assets/img/hobbies/swim.jpg")
        },
        {
          name: "hobbies.ultimate",
          img: require("@/assets/img/hobbies/ultimate.jpg")
        }
      ];
      return items;
    }
  }
});
